import React, { FC } from "react";
import IOApiTable from "../../../components/IOApiTable";
import { api, useApi } from "../../../api/api";
import { ButtonCell, TextCell } from "../../../components/Table";

interface VenuesConfigsIOApiTableProps {
    path?: string;
    actions: any;
    onInit: any;
    envColor: string;
    isFiltered?: boolean;
    items?: any[];
    searchValue?: string;
    remove: (record: Record<string, any>) => Promise<void>;
}

const VenueConfigsIOApiTable: FC<VenuesConfigsIOApiTableProps> = ({
    path,
    actions,
    onInit,
    envColor,
    isFiltered,
    items,
    searchValue,
    remove,
}) => {
    const configsApi = useApi(api.configs);

    function highlightText(text: string): JSX.Element {
        if (!searchValue || !text) {
            return <span>{text}</span>;
        }

        const escapedSearchValue = searchValue.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const regex = new RegExp(`(${escapedSearchValue})`, "gi");
        const parts = text.split(regex);

        return (
            <span>
                {parts.map((part, index) =>
                    regex.test(part) ? (
                        <mark key={index} style={{ backgroundColor: "yellow" }}>
                            {part}
                        </mark>
                    ) : (
                        <span key={index}>{part}</span>
                    ),
                )}
            </span>
        );
    }

    return (
        <IOApiTable api={configsApi} onInit={onInit} path={path} items={items} withoutTopButtons={true} definition>
            <ButtonCell
                header=""
                icon="history"
                onClick={actions?.historyFile}
                value={(x) => x.srckey}
                color={envColor}
                button={{ basic: false }}
            />
            <ButtonCell
                header=""
                icon="trash"
                onClick={remove}
                value={(_) => _}
                color={envColor}
                button={{ basic: false }}
            />
            <ButtonCell
                header="config"
                icon="arrow down"
                style={{ maxWidth: "250px", minWidth: "250px" }}
                value={(x) => x.srckey}
                label={(srckey) => srckey.split("/").reverse()[0]}
                onClick={actions?.read}
                color={envColor}
            />
            {isFiltered && (
                <TextCell
                    style={{
                        maxWidth: "200px",
                        minWidth: "45px",
                    }}
                    header="source"
                    value={(x) => highlightText(x.source)}
                />
            )}
            <TextCell header="Uploader" value={(x) => highlightText(x.uploader)} />
            <TextCell header="Author" value={(x) => highlightText(x.author)} />
            <TextCell header="Last Update" value={(x) => highlightText(x.created_at.split(".")[0])} />
            <TextCell header="Version" value={(x) => highlightText(x.version)} />
        </IOApiTable>
    );
};
export default VenueConfigsIOApiTable;
